import React from 'react';
import { ShippingRateSelector } from '../../components/ShippingRateSelector';

/**
 * Shipping Method card — wraps the ShippingRateSelector with a header
 * + Quote-Number badge. Locked-on-submit copy explains to the customer
 * why the displayed rate is final.
 */
export const ShippingMethodCard = ({
  orderNumber,
  shippingRates,
  selectedRate,
  setSelectedRate,
}) => (
  <div className="bg-white rounded-lg shadow-lg p-6" data-testid="review-shipping-card">
    <div className="flex items-start justify-between mb-1 flex-wrap gap-2">
      <div>
        <h3 className="text-lg font-bold text-[#4A7C59]">Shipping Method</h3>
        <p className="text-xs text-gray-500">
          Top 3 cheapest live Freightcom rates — locked to this order on submit
        </p>
      </div>
      {orderNumber && (
        <span
          className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-700 font-mono"
          data-testid="review-quote-name"
        >
          Quote: {orderNumber}
        </span>
      )}
    </div>
    <div className="mt-4">
      <ShippingRateSelector
        rates={shippingRates.rates}
        loading={shippingRates.loading}
        error={shippingRates.error}
        mockMode={shippingRates.mockMode}
        pkg={shippingRates.package}
        totalCarriers={shippingRates.totalCarriers}
        selectedServiceCode={selectedRate?.service_code}
        onSelect={setSelectedRate}
      />
    </div>
  </div>
);

export default ShippingMethodCard;
